const Refresh = ({ className = '' }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M11.4604 4.26977C10.4944 4.31377 9.52137 4.52277 8.58037 4.93077C5.06337 6.45677 3.16637 10.1508 3.75637 13.7698'
      stroke='#0FD08B'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.126 16.2152C19.57 15.3562 19.876 14.4092 19.993 13.3912C20.431 9.58218 18.179 6.09318 14.75 4.79418'
      stroke='#0FD08B'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.88525 2.84301L11.7263 3.81001L10.3443 6.20601'
      stroke='#0FD08B'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M21.6503 14.7014L19.3923 16.6784L18.0083 14.2834'
      stroke='#0FD08B'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.99804 19.8261L4.41504 16.8821L7.18104 16.8811'
      stroke='#0FD08B'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.94727 16.8838C5.46927 17.6988 6.13627 18.4368 6.95927 19.0468C10.0393 21.3298 14.1873 21.1258 17.0263 18.8048'
      stroke='#0FD08B'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default Refresh
